import { lazy } from 'react';

import { LayoutType, PageType } from '@shared/constants/constants';
import { ACTION_BACK_PATH, CMIS_PATH } from '@shared/constants/paths';
import { SERVICE_CATALOG_CODE } from '@shared/constants/serviceCatalog';
import type { RouteConfig } from '@shared/types/common.types';

const CMISPage = lazy(() => import('./pages/CMISPage'));

export const CMIS_ROUTES: RouteConfig[] = [
  {
    actionUrl: ACTION_BACK_PATH,
    availableViews: [LayoutType.PORTAL, LayoutType.MOBILE, LayoutType.STANDARD],
    component: () => <CMISPage />,
    displayTitle: () => 'Medical Alert & Adverse Drug <br/> Reaction / Drug Allergy',
    pageType: PageType.PRIVATE,
    path: CMIS_PATH,
    serviceCatalogCode: SERVICE_CATALOG_CODE.medicalAlertAndAdverseDrugReactionDrugAllergy,
  },
];
